import Reveal from "../components/Reveal";
import SectionHeading from "../components/SectionHeading";
import RfqBanner from "../components/RfqBanner";
import { PageBanner } from "./About";
import { INDUSTRIES } from "../data/content";

const Industries = () => (
  <>
    <PageBanner
      testId="industries-banner"
      eyebrow="Application Areas"
      title="Industries & Applications"
      description="The tooling, Dies and machined components we manufacture are used across a range of industrial application areas."
    />

    <section data-testid="industries-grid" className="py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {INDUSTRIES.map((ind, i) => (
            <Reveal key={ind.id} delay={(i % 3) * 0.05}>
              <article
                data-testid={`industry-card-${ind.id}`}
                className="h-full bg-white border border-slate-200 rounded-sm overflow-hidden group"
              >
                <div className="overflow-hidden">
                  <img
                    src={ind.img}
                    alt={ind.alt}
                    loading="lazy"
                    className="h-48 w-full object-cover group-hover:scale-[1.03] transition-transform duration-300"
                  />
                </div>
                <div className="p-6">
                  <h2 className="text-lg font-semibold text-slate-900">{ind.name}</h2>
                  <p className="mt-2 text-sm text-slate-600 leading-relaxed">{ind.desc}</p>
                </div>
              </article>
            </Reveal>
          ))}
        </div>

        <Reveal className="mt-12">
          <div className="border border-slate-200 bg-[#F8FAFC] p-6 rounded-sm max-w-3xl">
            <SectionHeading eyebrow="Please Note" title="" />
            <p className="text-sm text-slate-600 leading-relaxed -mt-2">
              The categories above describe application areas for the types of components we
              manufacture. Radiant Machine Tools manufactures to customer drawings and
              specifications; supply to any specific company or sector is confirmed only through
              direct enquiry.
            </p>
          </div>
        </Reveal>
      </div>
    </section>

    <RfqBanner />
  </>
);

export default Industries;
